import React from 'react';

import { Chip } from '@mui/material';

import type { LeFlashStatus } from '~/types/services/priceParrot';

import { LE_FLASH_STATUS_LABELS } from './constants';

const STATUS_COLORS: Record<LeFlashStatus, 'success' | 'info' | 'default'> = {
  now: 'success',
  upcoming: 'info',
  before: 'default',
  never: 'default',
};

interface Props {
  status: LeFlashStatus;
}

export default function CompetitorOfferLeFlashChip({ status }: Props) {
  return (
    <Chip
      size="small"
      variant={status === 'never' ? 'outlined' : 'filled'}
      color={STATUS_COLORS[status]}
      label={LE_FLASH_STATUS_LABELS[status]}
    />
  );
}
